export const WEBSITE_NON_REFUNDABLE_POLICY_ID = '72e0d93f-0f97-434f-b3aa-d901e18381d4'
export const WEBSITE_HOTELS_POLICY_ID = 'd9dd7935-0ff5-4ce9-b7d9-d8758b4e13c0'
